'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInt = require('./isInt');

var _isInt2 = _interopRequireDefault(_isInt);

var _getFloatingDigitsNumber = require('./getFloatingDigitsNumber');

var _getFloatingDigitsNumber2 = _interopRequireDefault(_getFloatingDigitsNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function getLabelBasedOnValue(_ref) {
  var size = _ref.size,
      finalSize = _ref.finalSize,
      value = _ref.value;

  var label = void 0;

  if (size != null && size !== finalSize) {
    if ((0, _isInt2.default)(value)) {
      label = Math.round(size / (finalSize || 0.1) * (parseFloat(value) || 0.1));
    } else {
      var newValue = size / finalSize * value;
      var floatingDigitsNumber = (0, _getFloatingDigitsNumber2.default)(value);

      newValue = newValue.toFixed(floatingDigitsNumber);
      label = newValue;
    }
  } else {
    label = value;
  }

  return isNaN(label) ? null : label;
}

exports.default = getLabelBasedOnValue;